import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=50f61968&scoped=true&"
import script from "./CartDetail.vue?vue&type=script&lang=js&"
export * from "./CartDetail.vue?vue&type=script&lang=js&"
import style0 from "./CartDetail.vue?vue&type=style&index=0&id=50f61968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f61968",
  null
  
)

export default component.exports